import RecommendedList from './RecommendedList';
export default RecommendedList;
